var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "fluid", attrs: { id: "da-wrapper" } }, [
    _c("div", { attrs: { id: "da-content" } }, [
      _c("div", { staticClass: "da-container clearfix" }, [
        _c("div", { attrs: { id: "da-error-wrapper" } }, [
          _c("div", { attrs: { id: "da-error-pin" } }),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c("h1", { staticClass: "da-error-heading" }, [
            _vm._v("Sorry！页面暂时无法访问...")
          ]),
          _vm._v(" "),
          _c(
            "p",
            { staticStyle: { "text-align": "left" } },
            [
              _vm._m(1),
              _c("br"),
              _c("br"),
              _vm._v(" "),
              _c("router-link", { attrs: { to: "/" } }, [_vm._v("医博士首页")]),
              _c("router-link", { attrs: { to: "/about" } }, [
                _vm._v("关于我们")
              ]),
              _c(
                "router-link",
                { attrs: { to: { path: "about", query: { switchTag: 3 } } } },
                [_vm._v("联系我们")]
              ),
              _c("router-link", { attrs: { to: "/help" } }, [
                _vm._v("新手帮助")
              ])
            ],
            1
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _vm._m(2)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "da-error-code" } }, [
      _c("br"),
      _c("span", [_vm._v("404")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      { staticStyle: { "font-size": "14px", "line-height": "24px" } },
      [
        _vm._v("可能原因："),
        _c("br"),
        _vm._v(" 网址有错误>请检查地址是否完整或存在多余字符"),
        _c("br"),
        _vm._v("\n          网址已失效>可能页面已删除，活动已下线等")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "da-footer" } }, [
      _c("div", { staticClass: "da-container clearfix" }, [
        _c("p", [
          _vm._v(
            "Copyright © 2012-2018 北京亿和博嘉教育科技有限公司 版权所有京ICP备12019974号"
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a86191f", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a86191f","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotFound.vue
// module id = null
// module chunks = 